// GroupChip.jsx — 第一百零三批：工单三面（审批列表 / 我的提交 / 详情头）共用的
// 组徽标。多项目制下「这张单属于哪个组」是裁决偏移的界面因子——审批人裁决前
// 必须一眼看到组。所以它**一律显示**，不按 groups.length 或「行组=当前组」隐藏：
// 这个信息不该因为多数人只有一个组就消失，按人数隐藏等于让恰恰需要它的那部分
// 会话看不见它。
//
// 组名从会话上下文（useAuth().groups）按 id 找，取名规则是 groups.mjs 的唯一一只
// labelGroupIds：认不出的 id 显示 `#<id>` 而**不静默丢**——挂在已归档组上的工单
// 是真实存在的状态，抹掉徽标只会让裁决者按错误的上下文判断。
import { Chip, Tooltip } from '@mui/material';
import { labelGroupIds } from '../api/groups.mjs';
import { useAuth } from '../auth/AuthContext.jsx';
import { useLang, useT } from '../i18n/index.mjs';

export default function GroupChip({ groupId }) {
  const { groups } = useAuth();
  const { lang } = useLang();
  const t = useT();
  // 老后端的行可能没有 projectGroupId：没有地面真值就不渲染，绝不猜一个组名。
  if (groupId == null) return null;
  const [label] = labelGroupIds([groupId], groups, lang);
  return (
    <Tooltip title={t('tickets.groupChip.tip')}>
      <Chip size="small" variant="outlined" color="info" label={label} />
    </Tooltip>
  );
}
